import { Injectable } from '@angular/core';
import { ProjectsOverviewApiService } from './api/projects-overview-api.service';

@Injectable({
  providedIn: 'root',
})
export class ProjectsOverviewService {
  constructor(private apiService: ProjectsOverviewApiService) {}

  getEventStreamedProjects$(ids: string[]) {
    return this.apiService.getProjects(ids);
  }
}
